export default __webpack_public_path__ + "static/media/expitem2.138a6be2.jpg";